import base from "./base.service";

const instance = base.service();

export const getAll = () => {
    return instance.get("/saglasnost/all"); 
};

export const getById = (id) =>
{
    return instance.get(`/saglasnost/${id}`);
}

export default {
    getAll, getById
};